import { Separator } from "@radix-ui/react-separator"
import { MoreHorizontalIcon, Trash2Icon } from "lucide-react"
import type { MouseEvent } from "react"
import { useState } from "react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

import { DeleteAccessManagerUserDialog } from "./delete-access-manager-user-dialog"
type AccessManagementActionsCellProps = {
  user: User
}
export const AccessManagementActionsCell: React.FC<
  AccessManagementActionsCellProps
> = ({ user }) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const handleDeleteButtonOnClick = (event: MouseEvent) => {
    event.stopPropagation()
    setShowDeleteDialog(true)
  }
  return (
    <DropdownMenu>
      <DeleteAccessManagerUserDialog
        userId={user.uuid}
        open={showDeleteDialog}
        setOpen={setShowDeleteDialog}
      />
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <MoreHorizontalIcon size={16} />
        </Button>
      </DropdownMenuTrigger>
      <Separator />
      <DropdownMenuContent align="end">
        <DropdownMenuItem className="cursor-pointer hover:text-destructive">
          <Button
            variant="ghost"
            size="icon"
            className="w-full justify-start"
            onClickCapture={(event) => handleDeleteButtonOnClick(event)}
          >
            <Trash2Icon size={16} className="mr-2" />
            Apagar
          </Button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
